import React from "react";
import { useEffect } from "react";

import { Switch, Route } from "react-router-dom";

import HomePage from "./pages/HomePage";
import RestaurantPage from "./pages/RestaurantPage";

import Navigation from "./components/Navigation";
import Loading from "./components/Loading";
import MessageBox from "./components/MessageBox";
import SignUp from "./pages/SignUp";
import Login from "./pages/Login";

import { useDispatch, useSelector } from "react-redux";
import { selectAppLoading } from "./store/appState/selectors";
import { getUserWithStoredToken } from "./store/user/actions";

function App() {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectAppLoading);

  useEffect(() => {
    dispatch(getUserWithStoredToken());
  }, [dispatch]);

  return (
    <html>
      {/* <Header /> */}

      <Navigation />
      <MessageBox />
      {isLoading ? <Loading /> : null}
      <div style={{ marginTop: "8%" }}>
        <Switch>
          <Route exact path="/restaurants/:id" component={RestaurantPage} />
          <Route path="/signup" component={SignUp} />
          <Route path="/login" component={Login} />
          <Route path="/" component={HomePage} />
        </Switch>
      </div>
    </html>
  );
}

export default App;
